import React, { useReducer } from "react";

import SearchInput from "./components/searchInput";
import SearchList from "./components/searchList";
import Reducer from "./reducer";
import Context from "./context";
import { initialState } from "./initialState";
import ModalTemplate from "../modal/modalTemplate";

const SearchFelid = ({ openModal }) => {
    const SearchIcon = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="search-icon"
            style={{
                position: 'absolute',
                top: '50%',
                left: '10px',
                transform: 'translateY(-50%)',
                width: '16px',
                height: '16px',
                color: '#888',
            }}
        >
            <circle cx="11" cy="11" r="8"/>
            <line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
    );

    const ShortcutLabel = () => (
        <span
            style={{
                position: 'absolute',
                top: '50%',
                right: '10px',
                transform: 'translateY(-50%)',
                fontSize: '12px',
                color: '#888',
            }}
        >
            Ctrl+K
        </span>
    );

    const InputField = () => (
        <input
            type="text"
            className="form-control"
            onClick={openModal}
            // placeholder="Search..."
            style={{
                paddingLeft: '30px',
                paddingRight: '50px',
                height: '36px',
                borderRadius: '4px',
                border: '1px solid #ccc',
            }}
        />
    );
 
    return (
        <div style={{ position: 'relative', display: 'inline-block' }}>
            <InputField/>
            <SearchIcon/>
            <ShortcutLabel/>
        </div>
    );
}

const SearchModal = () => {
    const [state, dispatch] = useReducer(Reducer, initialState);

    const openModal = () => dispatch({ type: 'IS_SHOW', show: true });
    const closeModal = () => dispatch({ type: 'IS_SHOW', show: false });

    return (
        <Context.Provider value={{ state, dispatch }}>
            <SearchFelid openModal = {openModal}/>
            <ModalTemplate
                show={state.show}
                closeFun={closeModal}
                size={"lg"}
                centered={false}
                title={null}
                body={
                    <>
                        <SearchInput />
                        <SearchList />
                    </>
                }
                footer={null}
            />
        </Context.Provider>
    );
}

export default SearchModal